import React from "react";
import Bg from "@/assets/images/product/party/bg.jpeg";
import LeadBg from "@/assets/images/product/party/lead.jpg";


const Party: React.FC = () => {
  return (
    <main className='warp-consult header-top'>
      <div className='warp-consult-header'>
        <img src={Bg} alt=""/>
      </div>
      <div className='home-page warp-visit-content-items'>
        <div className='content-item'>
          <div className='content-item-block'>
            <div className='b-content p-pre-wrap'>
              熙诚教育投资赓续红色基因，立足国企专业视角，为党政机关、国有企事业单位打造党建与业务深度融合一体化解决方案。作为中国咨询培训行业的国企先锋，熙诚教育投资持续深耕企业管理咨询与学习服务，助力企业明晰发展战略、高效落地执行，全面提升组织效能，赋能高质量发展。
            </div>
            <div className='b-content p-pre-wrap'>
              2026 年作为十五五开局关键之年，新时代党建紧扣发展大局，以筑牢政治忠诚为根本，纵深推进全面从严治党，牢固树立和践行正确政绩观，坚持科技引领赋能党建创新，聚力服务乡村振兴战略实施，以高质量党建引领保障经济社会高质量发展。
            </div>
            <div className='b-content p-pre-wrap'>
              我们通过'规划-赋能-实践’三层体系,将党建引领系统融入业务脉络,推动组织实现“高质量发展”将党建的“软实力”切实转化为企业治理与市场竞争中“看得见的生产力与竞争力”。
            </div>
          </div>
        </div>
        <img src={LeadBg} alt="" width='100%' style={{marginBottom: '70px'}}/>

      </div>

    </main>
  )
}

export default Party